import React from 'react';
import { Button } from './Button';
import { Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-[#0A1628] relative overflow-hidden" data-id="element-92">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#C6F432] opacity-5 rounded-full blur-[80px] pointer-events-none" data-id="element-93"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-94">
        <h2 className="text-4xl md:text-6xl font-anton text-white mb-8" data-id="element-95">
          La decisión es simple
        </h2>
        <p className="text-2xl text-gray-400 mb-4" data-id="element-96">
          Podés seguir improvisando…
        </p>
        <p className="text-3xl text-[#C6F432] font-bold mb-12" data-id="element-97">
          O podés convertirte en un profe con sistema.
        </p>

        <Button className="text-2xl py-6 px-12 mb-8 animate-pulse shadow-[0_0_40px_rgba(198,244,50,0.3)]" data-id="element-98">
          🎾 ACCEDÉ AHORA
        </Button>

        <div className="flex flex-wrap justify-center gap-6 text-gray-300 font-medium" data-id="element-99">
          <div className="flex items-center gap-2" data-id="element-100">
            <Check className="text-[#C6F432]" size={20} data-id="element-101" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center gap-2" data-id="element-102">
            <Check className="text-[#C6F432]" size={20} data-id="element-103" /> Pago seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-104">
            <Check className="text-[#C6F432]" size={20} data-id="element-105" /> Garantía total
          </div>
        </div>
      </div>
    </section>;
}